import FLIB from './funlibs.js';

import Card from './card.js';
import { ButtonStatus as BS, UserSubscribeType as UST } from '../enums.js';

export const Env = WXGAME.Env;
window.partitionConfig = window.partitionConfig || {};
/**
 * 王者荣耀、和平精英、英雄联盟手游、使命召唤手游、穿越火线手游、天涯明月刀、QQ飞车、 欢乐斗地主、 黎明觉醒、欢乐麻将
 */
// 春节大事件参与游戏分区信息
Object.assign(window.partitionConfig, {
  wx95a3a4d7c627e07d: true, // 王者荣耀
  wxc4c0253df149f02d: false, // 和平精英
  wx5a611599efa17e78: false, // 英雄联盟手游
  wxc933ffba7d9de4dc: false, // 使命召唤手游
  wx58164a91f1821369: false, // 穿越火线手游
  wxd9e0d500b5fb209f: true, // 天涯明月刀
  wx360b06d575d20cc3: true, // QQ飞车
  wx76fc280041c16519: false, // 欢乐斗地主
  wx10e2ae0624e95569: false, // 黎明觉醒 预约游戏不用选区服
  wx3bef52104e238bff: false, // 欢乐麻将
  wxd477edab60670232: false,
  wx095ef8ef7e64b291: true,
  wx7819539d83b9dc1e: true,
  wx44b60f3ea0534cd7: true,
  wx15e4ed4511fd50c9: false //预约游戏不用选分区
});

const fake_card_info = {
  cardid: 'pX1sst_6zPUa0R2DpPiWcFZz-Owk',
  openid: 'oX1sst6LyrF9-PqNYhyjBIgb35QY',
  timestamp: '1578919366',
  nonce_str: '1Q6t42etBv3QJDvMDenAGb8YPdolz2',
  signature: 'E86EE69872029C1D3F05814E345F198BEC6B193A',
  code: '3efbd095e1c65c6'
};

const mocks = top.mocks || false;

function __fillDemo(req) {
  req = __getMockKey(req);
  if (location.hostname != 'game.weixin.qq.com') {
    return mocks[req.cgi] || { errcode: 0, data: {}, mock: false };
  } else {
    // console.log(12, req, 'use cgi data');
    return false;
  }
}
function __getMockKey(req) {
  if (
    req.instance_id ==
    'Y4K9lAaz2qNEAq0vrLaZsYaf_tCPEAUJ61eva60nOtHxBCx7w_5JKeszD5KmFjvb5dIRZEjUoAzclisUBrSmaENVQ7yXlR5oqW8Iyo3N2nAzq0gSJ09aiGVech1pnphc'
  ) {
    req.cgi = 'cash_detail';
  } else if (
    req.instance_id ==
    'niqX9G09v2wbphDLwpzlkaiHqciXipjpBxGLLdLxynilICIp_B53YGBX8SiAzuXY7yWF1VzUZkiAKm1uaeTLwOYAOIAstuE-K0iNo4-B2onLq7l6eJAyzxXW4qGxqRpm'
  ) {
    req.cgi = 'thing_detail';
  } else if (
    req.instance_id ==
      'Y4K9lAaz2qNEAq0vrLaZsWbi1IKaL_qRoAPDEWob_VfxBCx7w_5JKeszD5KmFjvb5dIRZEjUoAzclisUBrSmaENVQ7yXlR5oqW8Iyo3N2nBGB9UysDrEc0HcQghuhupr' ||
    req.instance_id ==
      'Y4K9lAaz2qNEAq0vrLaZsahErHG7K4BN26FaPJIqLG2RsYQzrUQGNoQU3hWmpfvKRROMlPamsokYen9BPwS8cfsltQKAQR9AZTPtHWjZDzrs8_vHpi7O50Ad-pMpCz-T'
  ) {
    req.cgi = 'wish_detail';
  } else if (
    req.instance_id ==
    'Y4K9lAaz2qNEAq0vrLaZsUgSDd4ndAFlu-G8lux211LxBCx7w_5JKeszD5KmFjvb5dIRZEjUoAzclisUBrSmaENVQ7yXlR5oqW8Iyo3N2nDtnXw2LFYcDxB7dpce8miU'
  ) {
    req.cgi = 'card_detail';
  }
  return req;
}

function parseMsg(res) {
  res = res || {};
  let success = '';
  let msg = res.errMsg || res.err_msg || res.errmsg || '';
  if (res && msg.indexOf(':ok') != -1) {
    success = 'ok';
  } else {
    success = msg.indexOf('cancel') != -1 ? 'cancel' : 'fail';
  }
  return success;
}

function addCardReview(cbk, boo, res) {
  if (boo && res && res.errcode == 0) {
    let data = res.data || {};
    let record = data.record || {};
    cbk({ errcode: 0, data: record });
  } else {
    cbk({ errcode: 0, data: res });
  }
}

export default {
  Env,
  /**
   * 大事件查询奖励详情
   *
   * @param appid: 游戏appid
   * @param actid: 活动ID
   * @param encrypt: instance_id
   *
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return void: 无返回
   */
  getRewardDetail: function (appid, actid, encrypt, cbk) {
    let url = '/cgi-bin/gamespringfestivalprowap/getspringfestivalrewarddetail';
    let params = JSON.stringify({
      req: {
        appid,
        actid: +actid,
        instance_id: encrypt,
        plat_id: Env.isiOS ? 0 : 1
      },
      method: 'POST'
    });
    let req = { cgi: 'getspringfestivalrewarddetail', instance_id: encrypt };
    let mock = mocks ? __fillDemo(req) : false;
    if (mock) {
      if (cbk && typeof cbk == 'function') {
        cbk(true, mock);
      }
      return;
    }
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 打开心愿奖励
   *
   * @param encrypt: instance_id
   *
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return void: 无返回
   */
  openReward: function (encrypt, cbk) {
    let url = '/cgi-bin/gamespringfestivalprowap/openspringfestivalreward';
    let params = JSON.stringify({
      req: {
        instance_id: encrypt
      },
      method: 'POST'
    });
    // setTimeout(function() {
    //     cbk(true, { errcode: 0, errmsg: 'ok', data: {} });
    // }, 1000);
    // return;
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        //不管成功失败，全部当成功
        if (cbk && typeof cbk == 'function') {
          cbk(true, fail);
        }
      }
    );
  },
  /**
   * 请求发放奖励
   *
   * @param appid: 游戏appid
   * @param actid: 活动ID
   *
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return void: 无返回
   */
  sendRewardRequest: function (appid, actid, encrypt, cbk) {
    let url = '/cgi-bin/gamespringfestivalprowap/sendspringfestivaluserreward';
    let params = JSON.stringify({
      req: {
        appid,
        actid,
        instance_id: encrypt || '',
        platid: Env.isiOS ? 0 : 1
      },
      method: 'POST'
    });
    // PC版假装成功
    if (Env.isPC) {
      console.error('fake send request and return ok after 500ms');
      setTimeout(() => {
        cbk &&
          cbk(true, {
            errcode: 0,
            errmsg: 'ok',
            data: {
              status: 1,
              card_info: fake_card_info
            }
          });
      }, 500);
      return;
    }
    // console.log(111, appid, actid, token, url, params);
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 查询插卡详情并插卡功能接口
   *
   * @param appid: 游戏appid
   * @param actid: 活动ID
   * @param encrypt: instance_id
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param: 领卡结果展示，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return void: 无返回
   */
  addCard: function (
    appid,
    actid,
    encrypt,
    cbk = (msg) => {},
    isWechatGameAct = true,
    openid = ''
  ) {
    let _this = this;
    let func = function () {
      _this.getRewardDetail(appid, actid, encrypt, (boo, res) => {
        addCardReview(cbk, boo, res);
      });
    };
    this[isWechatGameAct ? 'sendRewardRequest' : 'getGiftDetail'](
      appid,
      actid,
      encrypt,
      (boo, res) => {
        if (boo) {
          if (res && res.errcode == 0) {
            let record = res.data || {};
            record.status = BS.STATUS_NOT_RECEIVE;
            let not_got =
              record.status == BS.STATUS_NOT_RECEIVE_HAS_CARD ||
              record.status == BS.STATUS_NOT_RECEIVE;
            let has_card = record.card_info && record.card_info.code && record.card_info.cardid;
            if (not_got && has_card) {
              if (Env.isiOS) {
                // 上报插卡成功，标识成功后，再查一次确认成功
                _this.reportCardAdded(encrypt, (bo, ret) => {});
                Card.addCard(record.card_info, (msg) => {
                  if (msg && msg.success == 'ok') {
                    setTimeout(func, 10);
                  } else {
                    setTimeout(func, 10);
                  }
                });
              } else {
                let card = record.card_info || {};
                FLIB.openMiniApp(
                  {
                    path: `pages/add-card/index.html?instance_id=${encrypt}&openid=${
                      card.openid || openid
                    }`,
                    appid: appid,
                    targetAppId: 'wxc4a8208dc3533550',
                    // TODO : trial , 正式发布时，改为 release
                    envVersion: 'release'
                  },
                  1000,
                  (res) => {
                    func();
                  }
                );
              }
            } else {
              cbk({ errcode: 1, data: record, errmsg: '卡券已被领取,请进入卡包查看' });
            }
          } else {
            cbk(res);
          }
        } else {
          cbk({ errcode: 2, errmsg: '服务器繁忙，请稍后再试' });
        }
      }
    );
  },
  /**
   * 上报插卡成功
   *
   * @param encrypt: instance_id
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return void: 无返回
   */
  reportCardAdded1: function (encrypt, cbk) {
    let url = '/cgi-bin/gamespringfestivalprowap/sendcardsucc';
    let params = JSON.stringify({
      req: {
        instance_id: encrypt
      },
      method: 'POST'
    });
    let req = { cgi: 'sendcardsucc', instance_id: encrypt };
    let mock = mocks ? __fillDemo(req) : false;
    if (mock) {
      if (cbk && typeof cbk == 'function') {
        cbk(true, mock);
      }
      return;
    }
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, fail);
        }
      }
    );
  },
  reportCardAdded: function (encrypt, cbk) {
    let xhr = new XMLHttpRequest();
    let url = '/cgi-bin/gamespringfestivalprowap/sendcardsucc';
    let _timeout = null;
    let params = JSON.stringify({
      req: {
        instance_id: encrypt
      }
    });
    xhr.open('POST', url, true);
    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        let suc = xhr.responseText;
        try {
          suc = JSON.parse(suc);
        } catch (e) {
          suc = { errcode: 0 };
        }
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
        clearTimeout(_timeout);
        xhr = null;
      }
    };
    xhr.setRequestHeader('Content-type', 'application/json');
    _timeout = setTimeout(() => {
      if (cbk && typeof cbk == 'function') {
        cbk(true, { errcode: 0 });
      }
      xhr = null;
    }, 30000);
    xhr.send(params);
  },
  /**
   * 保存收货地址
   *
   * @param cbk  : 查询结果回调函数, Function
   * @return void: 无返回
   */
  sendAddress: function (req, cbk) {
    let url = '/cgi-bin/gamespringfestivalprowap/setuseraddress';
    let params = JSON.stringify({
      req: { address: req },
      method: 'POST'
    });
    // console.log(111, appid, actid, token, url, params);
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 获取收货地址
   *
   * @param cbk  : 查询结果回调函数, Function
   * @return void: 无返回
   */
  getAddress: function (req, cbk) {
    let url = '/cgi-bin/gamespringfestivalprowap/getuseraddress';
    let params = JSON.stringify({
      req,
      method: 'POST'
    });
    let mock = __fillDemo({ cgi: 'getuseraddress' });
    if (mock) {
      if (cbk && typeof cbk == 'function') {
        cbk(true, mock);
      }
      return;
    }
    // console.log(111, appid, actid, token, url, params);
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 预约游戏接口
   *
   */
  reserveRewardGame: function (appid, actid, cbk) {
    let url = '/cgi-bin/gamespringfestivalprowap/makespringfestivaluserappointment';
    let params = JSON.stringify({
      req: {
        appid,
        actid: +actid,
        plat_id: Env.isiOS ? 0 : 1
      },
      method: 'POST'
    });
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },

  /**
   * 奖励列表接口
   * @param appid: 游戏appid
   * @param actid: 活动ID
   * @param token: 加密串
   *
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return
   */
  loadRewardList: function (actid, cbk) {
    let url = '/cgi-bin/gamespringfestivalprowap/getspringfestivalrewardlist';
    let params = JSON.stringify({
      actid,
      method: 'POST'
    });
    let mock = __fillDemo({ cgi: 'getspringfestivalrewardlist' });
    if (mock) {
      if (cbk && typeof cbk == 'function') {
        cbk(true, mock);
      }
      return;
    }
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 查询用户订阅消息通知状态
   * @param type: 订阅类型
   *
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return
   */
  getReserveStatus: function (cbk, type = UST.USER_SUBSCRIBE_GLOBAL_WISH_OPEN) {
    let url = '/cgi-bin/gamespringfestivalprowap/getspringfestivalusersubscribe';
    let params = JSON.stringify({
      req: { type },
      method: 'POST'
    });
    let mock = __fillDemo({ cgi: 'getspringfestivalusersubscribe' });
    if (mock) {
      if (cbk && typeof cbk == 'function') {
        cbk(true, mock);
      }
      return;
    }
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 用户订阅消息通知
   * @param type: 订阅类型
   *
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return
   */
  setReserveStatus: function (cbk, type = UST.USER_SUBSCRIBE_GLOBAL_WISH_OPEN) {
    let url = '/cgi-bin/gamespringfestivalprowap/springfestivalusersubscribe';
    let params = JSON.stringify({
      req: { type },
      method: 'POST'
    });
    let mock = __fillDemo({ cgi: 'springfestivalusersubscribe' });
    if (mock) {
      if (cbk && typeof cbk == 'function') {
        cbk(true, mock);
      }
      return;
    }
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 常规活动礼包详情
   *
   * @param appid: 游戏appid
   * @param actid: 活动ID
   * @param token: 加密串
   *
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return void: 无返回
   */
  getGiftDetail: function (appid, act_id, encrypt, cbk) {
    let url = '/cgi-bin/gameactmgrwap/actmgrgetrewarddetail';
    let params = {
      data: encodeURIComponent(
        JSON.stringify({
          req: {
            appid,
            act_id,
            encrypt,
            plat_id: Env.isiOS ? 0 : 1
          }
        })
      )
    };
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 常规活动请求发放礼包
   *
   * @param appid: 游戏appid
   * @param actid: 活动ID
   * @param token: 加密串
   *
   * @param cbk  : 查询结果回调函数, Function
   * @param cbk.param[0]: 请求是否成功，无网络错误, Boolean, true/false
   * @param cbk.param[1]: 发货cgi返回信息，Object, 如 {errcode:0, data: {}, errmsg: 'xxx'}
   *
   * @return void: 无返回
   */
  sendGiftRequest: function (appid, actid, token, cbk) {
    let url = '/cgi-bin/gameactmgrwap/actmgrusergotreward';
    let params = {
      data: encodeURIComponent(
        JSON.stringify({
          req: {
            appid,
            act_id: actid,
            encrypt: token,
            plat_id: Env.isiOS ? 0 : 1
          }
        })
      )
    };
    WXGAME.xhrCallCgi(
      url,
      params,
      (suc) => {
        if (cbk && typeof cbk == 'function') {
          cbk(true, suc);
        }
      },
      (fail) => {
        if (cbk && typeof cbk == 'function') {
          cbk(false, fail);
        }
      }
    );
  },
  /**
   * 查询游戏是否分区，以返回值中(jsdata,jspath,jsparams都不为空)，是否包含区服信息
   *
   * @param appid:    游戏appid
   * @param cbk:      回调函数，入参
   * @param isWechatGameAct: 大事件活动专用
   *
   * @return void
   * request_is_ok    Boolean     if some network error happened
   *                              if false,   don't trust has_partition value
   * has_partition    Boolean     true/false
   */
  hasPartition: function (appid, cbk, isWechatGameAct = false) {
    console.log('check partition', appid, partitionConfig[appid]);
    if (appid in partitionConfig) {
      if (typeof cbk == 'function') {
        console.log('check partition', appid, partitionConfig[appid]);
        cbk(true, partitionConfig[appid]);
      }
    } else {
      let k = `${appid}_ing`;
      if (partitionConfig[k]) {
        return;
      }
      partitionConfig[k] = partitionConfig[k] || [];
      partitionConfig[k].push(cbk);
      let url = '/cgi-bin/partition';
      let purl = '/cgi-bin/gamespringfestivalprowap/getapppartition';
      let param = {
        appid,
        platid: WXGAME.Env.isiOS ? 0 : 1
      };
      let params = {
        j: encodeURIComponent(JSON.stringify(param)),
        method: 'POST'
      };
      let mock = __fillDemo({ cgi: 'getapppartition' });
      if (mock) {
        if (cbk && typeof cbk == 'function') {
          cbk(true, mock);
        }
        return;
      }
      //
      if (isWechatGameAct) {
        url = purl;
        params = JSON.stringify({
          req: param,
          method: 'POST'
        });
      }
      WXGAME.xhrCallCgi(
        url,
        params,
        (suc) => {
          if (cbk && typeof cbk == 'function') {
            let isSucc = suc && ((suc.base && suc.base.ret == 0) || suc.errcode == 0);
            if (isSucc) {
              let hasPartition =
                'jspath' in suc
                  ? suc.jspath != '' && suc.jsparam != '' && suc.jsdata != ''
                  : suc.data && suc.data.partition;
              partitionConfig[appid] = hasPartition;
              partitionConfig[k].forEach((cb) => {
                cb(true, partitionConfig[appid]);
              });
            } else {
              partitionConfig[k].forEach((cb) => {
                cb(false, 'check_again');
              });
            }
            delete partitionConfig[k];
          }
        },
        (fail) => {
          if (cbk && typeof cbk == 'function') {
            partitionConfig[k].forEach((cb) => {
              cb(false, 'check_again');
            });
          }
          delete partitionConfig[k];
        }
      );
    }
  }
};
